import HTTP from '../../http';

// initial state
// shape: [{ text }]
const state = {
  posts: []
}

// getters
const getters = {
  getPosts: state => state.posts
}

// actions
const actions = {
	"LOAD_POSTS": function ({ commit }) {
		HTTP.get('/posts').then((response) => {
			commit('ADD_POSTS', { posts: response.data })
		}, (err) => {
			console.log(err)
		})
	},
	"ADD_POST": function ({ commit }, text) {
		console.log(text)
		HTTP.post('/posts',{
		    text: text.text,
		  }).then((response) => {
			commit('ADD_POST', { post: response.data })
		}, (err) => {
			console.log(err)
		})
	}
}

// mutations
const mutations = {
  ["ADD_POST"] (state, { post }) {
    state.posts.push(post)
  },
  ["ADD_POSTS"] (state, { posts }) {
	  state.posts = posts
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/simple-request.js